<template>
  <a-dropdown v-if="actions && actions.length > 0" :disabled="disabled">
    <a-menu slot="overlay" @click="handleMenuClick">
      <a-menu-item v-for="item in actions" :key="item.value">
        {{ item.label }}
      </a-menu-item>
    </a-menu>
    <Button style="background: rgba(0, 32, 46, 0.06)" :icon="typeIcon" :ghost="ghost" :border="border">{{
      title
    }}</Button>
  </a-dropdown>
</template>

<script>
import { Button } from "@/components";

export default {
  name: "ButtonDropdown",
  components: { Button },
  data() {
    return {};
  },
  props: {
    actions: {
      type: Array,
      default: function() {
        return [];
      },
    },
    isRadioType: {
      type: Boolean,
      default: false,
    },
    typeIcon: {
      type: String,
      default: "",
    },
    title: String,
    ghost: {
      type: Boolean,
      default: true,
    },
    border: {
      type: Boolean,
      default: false,
    },
    handleClick: Function,
    isEmit: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleMenuClick(event) {
      if (this.isEmit) {
        this.$emit("click", event.key);
      } else if (this.isRadioType) {
        this.$emit("click", event.target.value);
      } else {
        this.handleClick(event.key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-dropdown-trigger {
  width: 100%;
}

.radioStyle {
  padding: 0 12px;
  display: block;
  height: 30px;
  line-height: 30px;
}
</style>
